import { render, staticRenderFns } from "./view-more.vue?vue&type=template&id=b047a1be&scoped=true"
import script from "./view-more.vue?vue&type=script&lang=js"
export * from "./view-more.vue?vue&type=script&lang=js"
import style0 from "./view-more.vue?vue&type=style&index=0&id=b047a1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b047a1be",
  null
  
)

export default component.exports